import React from 'react';
const AdminFooter = () => {
  return (
    <footer className="admin-footer">
        <p>© Copyright {new Date().getFullYear()} AppRely Technologies. All rights reserved.</p>
    </footer>
  )
}

export default AdminFooter;